import type { Position as LowercasePos } from '../types/CustomContext';
import type { Position } from '../types/test';

export default (pos: Position): LowercasePos => ({
  x: pos.X ?? pos.x,
  y: pos.Y ?? pos.y,
  z: pos.Z ?? pos.z,
});
